import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const requestConfig = { headers: { "content-type": "multipart/form-data" } };

export const addProductPic = async (params: {
  productId?: number;
  data: AddProductPicReqT;
}) =>
  axios.post(
    Routes.PRODUCT + "/" + params.productId + "/" + Routes.ADD_PRODUCT_PIC,
    params.data,
    requestConfig
  );

export const useAddProductPic = () => {
  return useMutation({
    mutationKey: [Keys.EDIT_USER_MUT],
    mutationFn: addProductPic,
  });
};
